module.exports = __webpack_public_path__ + "assets/img/17.8c18a8f9.png";